import { Injectable } from '@angular/core';
import { GenericRequest } from '@app/core/models/request-status.model';
import { Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';
import { clearProduct, getPrice, getProduct, getStock } from '@b2b/features/product/core/store/actions/product.actions';
import { selectProduct, selectProductPrice, selectProductStock } from '@b2b/features/product/core/store/selectors/product.selectors';
import { Product } from '@b2b/features/product/core/utilities/product.model';
import { Price } from '@b2b/features/product/core/utilities/price.model';
import { GetStockResponse } from '@b2b/features/product/core/utilities/stock.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private store: Store) {}

  clearProduct() {
    this.store.dispatch(clearProduct());
  }

  getProduct(): Observable<GenericRequest<Product>> {
    return this.store.select(selectProduct);
  }

  takeProduct(): Observable<Product> {
    return this.store.select(selectProduct).pipe(
      filter(state => !state.isPristine && !state.isLoading && !!state.data),
      map(state => state.data!),
    );
  }

  getPrice(): Observable<GenericRequest<Price>> {
    return this.store.select(selectProductPrice);
  }

  getStock(): Observable<GenericRequest<GetStockResponse>> {
    return this.store.select(selectProductStock);
  }

  loadProduct(productID: string) {
    this.store.dispatch(getProduct({ productID }));
  }

  loadPrice(productID: string) {
    this.store.dispatch(getPrice({ productID }));
  }

  loadStock(productID: string) {
    this.store.dispatch(getStock({ productID }));
  }
}
